import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload = {}) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_BALANCES)
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch balances',
        data: {
          customerBalance: 0,
          riderBalance: 0,
          restaurantBalance: 0,
          pendingBalance: 0,
          totalBalance: 0,
        },
      }
    }

    const data = raw.data || {}

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        customerBalance: data.customerBalance || 0,
        riderBalance: data.riderBalance || 0,
        restaurantBalance: data.restaurantBalance || 0,
        pendingBalance: data.pendingBalance || 0,
        totalBalance: data.totalBalance || 0,
        customerCount: data.customerCount || 0,
        riderCount: data.riderCount || 0,
        restaurantCount: data.restaurantCount || 0,
      },
    }
  },
}
